import { render, staticRenderFns } from "./ApprovalFormsEditorId.vue?vue&type=template&id=3594e9b2&scoped=true&"
import script from "./ApprovalFormsEditorId.vue?vue&type=script&lang=js&"
export * from "./ApprovalFormsEditorId.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFormsEditorId.vue?vue&type=style&index=0&id=3594e9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594e9b2",
  null
  
)

export default component.exports